export default [
  { id: "submitted", name: "Enviado" },
  { id: "in_review", name: "Em análise" },
  { id: "inconsistent", name: "Com inconsistência" },
  { id: "validated", name: "Validado" },
  { id: "rejected", name: "Rejeitado" },
];
